export default function({ route, redirect }) {
  if (route.name === 'index') {
    redirect('/zakazky/')
  }
}
